import { render, staticRenderFns } from "./DownloadLanding.vue?vue&type=template&id=8c413d82&scoped=true&"
import script from "./DownloadLanding.vue?vue&type=script&lang=js&"
export * from "./DownloadLanding.vue?vue&type=script&lang=js&"
import style0 from "./DownloadLanding.vue?vue&type=style&index=0&id=8c413d82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c413d82",
  null
  
)

export default component.exports